import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_PAGE_HEIGHT } from '../../../styles/constants';
import { UiAlpha } from '../../../styles/ui-alpha';

export const useStyles = makeStyles<Theme>()((theme) => ({
  listObserverWrapper: {
    height: `calc(${MAX_PAGE_HEIGHT} - 250px)`,
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(-1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1, 1.5),
    borderRadius: 10,
    cursor: 'pointer',
    marginTop: theme.spacing(1),

    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shortest,
    }),

    '&:first-of-type': {
      marginTop: 0,
    },

    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  rowSelected: {
    backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Tint),
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Tint),
    },
  },
  rowText: {
    flex: 1,
    minWidth: 0,
  },
  userName: {
    fontWeight: 600,
    ...theme.mixins.appEllipsis,
  },
  userLogin: {
    fontSize: 13,
    lineHeight: '18px',
    color: theme.palette.text.secondary,
    ...theme.mixins.appEllipsis,
  },
  checkIcon: {
    flexShrink: 0,
  },
  emptyHintWrapper: {
    marginBottom: theme.spacing(1.5),
  },
  emptyHint: {
    padding: theme.spacing(2.5, 1),
    textAlign: 'center',
  },
}));
